<!--主页右侧的新闻动态-->
<template>
  <div class="news-rightItem">
    <a class="newitem-title">
      <router-link :to="'/newsArticle/'+articleId+'/news'" style="color: #000000">{{title}}</router-link>
      <img class="newitem-newlab" src="../../assets/img/newLab.png" />
    </a>
    <!-- <p class="newitem-text">
      {{rightnewTest}}
      <router-link :to="'/newsArticle/'+articleId+'/news'" style="color:#337ab7;">详情</router-link>
    </p> -->
    <div class="newitem-footer">
      <p class="newitem-time">
        <img src="../../assets/img/timeLock.png"/> {{rightnewTime}}
      </p>
      <p class="newitem-from">来源：{{rightnewAuthor}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['rightnewTitle', 'rightnewTest', 'rightnewTime', 'rightnewAuthor', 'articleId', 'title'],
  data () {
    return {
    }
  }
}
</script>
<style>
  .news-rightItem{
    width: 100%;
    margin-top: 0px;
    margin-bottom:14px;
    padding-top: 6px;
    padding-left: 10px;
    padding-right:10px;
    text-align: left;
  }
  .newitem-newlab{
    margin-top: -14px;
    float: right;
  }
  .newitem-footer{
    width: 100%;
    height: 26px;
    border-bottom: 1px solid #d7d7d7;
    margin-top: 4px;
  }
  .newitem-time{
    margin-bottom: 0px;
    float: left;
    color: #999999;
    font-size: 12px;
  }
  .newitem-from{
    margin-bottom: 0px;
    float: right;
    color: #999999;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/new-rightItem.vue